import React, { useEffect, useState } from 'react'
import { DatePicker, Select } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import { DataTable } from '../../../../admincore'

import { fullName } from '../../../../utils'

import { loadPeople } from '../../../people'

import TripDetails from './TripDetails'
// import data from './data.json'

const strong = title => <span className="font-weight-bold">{title}</span>

const TripsList = props => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const people = useSelector(s => s.people)
  const { isMobileView } = useSelector(s => s._settings)

  const [closedAtBeginDate, setClosedAtBeginDate] = useState(null)
  const [closedAtEndDate, setClosedAtEndDate] = useState(null)
  const [person, setPerson] = useState('all')

  useEffect(() => {
    dispatch(loadPeople({ limit: 1000 }))
  }, [])

  const renderExpandIcon = values => {
    const type = values.expanded ? 'caret-down' : 'caret-right'

    return <CaretRightOutlined style={{ fontSize: 10 }} type={type} />
  }

  const handleDateChange = range => {
    setClosedAtBeginDate(range[0])
    setClosedAtEndDate(range[1])
  }

  const handlePersonChange = value => {
    setPerson(value || 'all')
  }

  const getFilters = () => {
    const { employee } = props

    const format = 'YYYY-MM-DD'

    let filters = {}

    if (closedAtBeginDate) {
      filters = {
        closed_at_begin_date: closedAtBeginDate.format(format),
      }
    }

    if (closedAtEndDate) {
      filters = {
        ...filters,
        closed_at_end_date: closedAtEndDate.format(format),
      }
    }

    if (employee) {
      filters = {
        ...filters,
        employee,
      }
    }

    if (person && person !== 'all') {
      filters = {
        ...filters,
        employee: person,
      }
    }

    return filters
  }

  const handleClearFilters = () => {
    setClosedAtEndDate(null)
    setClosedAtBeginDate(null)
    setPerson('all')
  }

  const columns = [
    {
      title: strong(<FormattedMessage id="common.trips_list.columns.date_time" />),
      dataIndex: 'created_at',
      sorter: false,
      width: 120,
      render: date => {
        date = moment.utc(date).local()

        return (
          <>
            <div>{strong(date.format('YYYY-MM-DD'))}</div>
            <div className="text-muted font-weight-bold">{date.format('HH:mm')}</div>
          </>
        )
      },
    },
    {
      title: strong(<FormattedMessage id="common.trips_list.columns.person" />),
      dataIndex: 'client',
      sorter: false,
      render: client => {
        return (
          client && (
            <>
              <div>{fullName(client)}</div>
              <div className="text-muted mt-1">{client.phone}</div>
            </>
          )
        )
      },
    },
    {
      title: strong(<FormattedMessage id="common.trips_list.columns.pickup" />),
      sorter: false,
      render: (_, record) => {
        const point = record.route_points[0]
        const { name, address_name: address } = point

        return (
          <>
            <div>{name}</div>
            <div style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className="text-muted">
              {address}
            </div>
          </>
        )
      },
    },
    {
      title: strong(<FormattedMessage id="common.trips_list.columns.dropoff" />),
      ellipsis: true,
      sorter: false,
      render: (_, record) => {
        const point = record.route_points[record.route_points.length - 1]
        const { name, address_name: address } = point

        return (
          <>
            <div>{name}</div>
            <div style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className="text-muted">
              {address}
            </div>
          </>
        )
      },
    },
    {
      title: strong(<FormattedMessage id="common.trips_list.columns.cost" />),
      dataIndex: 'final_price',
      render: price => (price ? strong(`${price} lei`) : <div className="text-muted">n / a</div>),
      sorter: false,
      width: 120,
    },
  ]

  const search = (
    <>
      <Select
        value={person}
        style={{ minWidth: 200 }}
        showSearch
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={handlePersonChange}
        allowClear
      >
        <Select.Option value="all">{intl.formatMessage({ id: 'common.trips_list.filters.all_people' })}</Select.Option>
        {people.data.map(p => (
          <Select.Option key={p.id} value={p.user_id}>
            {fullName(p)}
          </Select.Option>
        ))}
      </Select>
      <DatePicker.RangePicker className="ml-2" value={[closedAtBeginDate, closedAtEndDate]} onChange={handleDateChange} />
    </>
  )

  const { loadAction, dataSource } = props

  console.log('dataSource', dataSource)

  return (
    <div style={isMobileView ? { overflowX: 'auto' } : {}}>
      <DataTable
        style={isMobileView ? { width: 900 } : {}}
        columns={columns}
        dataSource={dataSource}
        loadAction={loadAction}
        filters={getFilters()}
        customSearch={search}
        expandRowByClick
        expandIcon={renderExpandIcon}
        expandedRowRender={trip => <TripDetails trip={trip} />}
        onClearFilters={handleClearFilters}
      />
    </div>
  )
}

export default TripsList
